<script lang="ts">
	import { Text } from '@Shelly/shelly-design-system';
	import { format } from 'src/services/i18n';
	import { createEventDispatcher } from 'svelte';

	export let disabled = false;

	const dispatch = createEventDispatcher<{ loginClick: void }>();

	const handleLoginClick = (): void => {
		if (disabled) {
			return;
		}

		dispatch('loginClick');
	};
</script>

<hr class="mt-xl mb-xl" />

<div class="text-center">
	<Text class={`d-inline-block text-small${disabled ? ' disabled' : ''}`}>
		{$format('text_have_an_account', { default: 'Have an account?' })}
	</Text>
	<Text
		class={`d-inline-block link-styles text-small${disabled ? ' disabled' : ''}`}
		on:click={handleLoginClick}
	>
		{$format('login', { default: 'Log in' })}
	</Text>
</div>
